import { OPEN_PASSKEY_MANAGEMENT_DRAWER, CLOSE_PASSKEY_MANAGEMENT_DRAWER } from './action';

const initialState = {
  isOpen: false,
  employeeId: null,
};

const passkeyManagementDrawer = (state = initialState, action = {}) => {
  switch (action.type) {
    case OPEN_PASSKEY_MANAGEMENT_DRAWER:
      return {
        ...state,
        isOpen: true,
        employeeId: action.payload,
      };

    case CLOSE_PASSKEY_MANAGEMENT_DRAWER:
      return {
        ...state,
        isOpen: false,
      };

    default:
      return state;
  }
};

export default passkeyManagementDrawer;
